export default __webpack_public_path__ + "static/media/average_outbound_duration.33d65269.svg";